import {OverlayTrigger, Tooltip} from "react-bootstrap";
import React from "react";
import C from "helpers/HelpConstants";

const ServiceGroupCrudTableRow = ({el, i, editData, deleteData, styles}) => {
    let {code, name, description, isVisible, serviceCodes, _id} = el;

    const badgeStyle = {
        display: 'inline-block',
        backgroundColor: '#0d6efd',
        color: 'white',
        padding: '2px 8px',
        borderRadius: '12px',
        fontSize: '0.75rem',
        marginRight: '5px',
    };

    const style = {
        td: {
            padding: "15px"
        },
        cell1: {
            maxWidth: '250px', 
            whiteSpace: 'normal', 
            wordWrap: 'break-word',
            padding: "15px"
        },
        cell2: {
            padding: "15px"
        }, 
        row1: {
            borderBottom: "1px solid #c1b2b2"
        }
    }

    return (
        <tr style={style.row1} key={code}>
            <th style={style.cell2} scope="row" >{i + 1}</th>
            <td style={style.cell2}>{code}</td>
            <td style={style.cell2}>{name}</td>
            <td style={style.cell2}>{description}</td>
            <td style={style.cell2}>
                {Array.isArray(serviceCodes) && serviceCodes.length > 0 ? (
                    serviceCodes.map((code, idx) => (
                   <span key={idx} style={badgeStyle}>
                        {code}
                    </span>
                    ))
                ) : (
                    <span className="text-muted">Sin servicios</span>
                )}
            </td>
            <td >{isVisible ? 'Si' : 'No'}</td>
            <td >
                <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Editar</Tooltip>}>
                    <button type="button" className="btn btn-sm btn-success me-2"
                            onClick={() => editData(el)}>
                        <i className="bi bi-pencil-square"/></button>
                </OverlayTrigger>
                <OverlayTrigger placement="top"  overlay={<Tooltip  id="tooltip-top">Eliminar</Tooltip>}>
                    <button type="button" className="btn btn-sm btn-danger"
                            disabled={!el.canDelete} onClick={() => deleteData(_id)}>
                        <i className="bi bi-trash"/></button>
                </OverlayTrigger>
            </td>
        </tr>
    );
}
export default ServiceGroupCrudTableRow;
